import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SabisNgxDialogComponent } from './dialog.component';
import { SabisNgxIconsModule } from '../sabis-icons/sabis-icons.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    SabisNgxDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    SabisNgxIconsModule
  ],
  exports: [
    SabisNgxDialogComponent
  ]
})
export class SabisNgxDialogModule { }
